const AUTH_TOKEN_KEY = 'authToken';

export const storeAuthToken = (token) => {
    try {
        localStorage.setItem(AUTH_TOKEN_KEY, token);
    } catch (error) {
        console.error('Error storing auth token:', error);
    }
};

export const getAuthToken = () => {
    try {
        return localStorage.getItem(AUTH_TOKEN_KEY);
    } catch (error) {
        console.error('Error getting auth token:', error);
        return null;
    }
};

export const clearAuthToken = () => {
    try {
        localStorage.removeItem(AUTH_TOKEN_KEY);
    } catch (error) {
        console.error('Error clearing auth token:', error);
    }
};